import { patchComponent } from '../_use';
import UiIcon from '../icon';
import { ICON_LOADING_CIRCLE_12_H2 } from '@futuweb/future-icon';
UiIcon.add([ICON_LOADING_CIRCLE_12_H2]);
export const SIZE_MAP = {
  small: 16,
  middle: 28,
  large: 48
};
const indicatorProps = {
  size: {
    type: [Number, String]
  },
  color: {
    type: String
  }
};
const UiIndicator = patchComponent({
  name: 'UiIndicator',
  props: indicatorProps,
  components: {
    UiIcon
  },
  computed: {
    style() {
      const style = {};
      // 处理大小
      let size;
      if (typeof this.size === 'number') {
        size = this.size;
      } else if (typeof this.size === 'string') {
        return style;
      }
      style.fontSize = "".concat(size, "px");
      return style;
    }
  },
  watch: {
    color: {
      immediate: false,
      deep: true,
      handler() {
        this.initColor();
      }
    }
  },
  methods: {
    initColor() {
      var _this$$refs$uiIndica;
      const stopList = (_this$$refs$uiIndica = this.$refs['ui-indicator-flower__circle']) === null || _this$$refs$uiIndica === void 0 ? void 0 : _this$$refs$uiIndica.$el.getElementsByTagName('stop');
      for (const item of stopList) {
        if (item && item.style) {
          item.style['stop-color'] = this.color;
        }
      }
      // 以下写法编译之后stopList会会多嵌套一层数组导致报错
      // let stopList = [...(this.$refs['ui-indicator-flower__circle']?.$el).getElementsByTagName('stop')];
      // stopList.forEach((item) => {
      //   if (item && item.style) {
      //     item.style['stop-color'] = this.color;
      //   }
      // });
    }
  },
  mounted() {
    this.initColor();
  },
  render() {
    const h = arguments[0];
    return h("span", {
      "class": "ui-indicator ui-indicator-flower",
      "style": this.style
    }, [h(UiIcon, {
      "class": "ui-indicator-flower__circle",
      "ref": "ui-indicator-flower__circle",
      "attrs": {
        "name": ICON_LOADING_CIRCLE_12_H2.name,
        "size": "12px"
      }
    })]);
  }
});
export default UiIndicator;